import React from 'react';
import {ItemPresenter} from "../ItemPresenter";

const className = "boarsteakmeat";

function GIBoarSteakMeat() {
  return (
    <ItemPresenter imagePath={`/images/gameItems/${className}.png`} tooltipText={className} />
  );
}

export default GIBoarSteakMeat;